module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "companies"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onAddCompany($event)
      }
    }
  }, [_vm._v("\n          Add new company\n        ")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table text-center table-hover border mt-4"
  }, [_c('thead', [_c('tr', _vm._l((_vm.companiesFields), function(item, key) {
    return _c('th', {
      class: [(key != 'index') ? 'text-left' : 'text-center', 'align-middle']
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.companies.filter(_vm.isInFilter)), function(item, index) {
    return [_c('tr', {
      on: {
        "click": function($event) {
          return _vm.onClickCompany($event, item.id)
        }
      }
    }, [_c('td', {
      staticClass: "align-middle index-cell"
    }, [_vm._v("\n            " + _vm._s(+index + 1) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle text-cell"
    }, [_c('div', {
      staticClass: "cell__text"
    }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle area-cell"
    }, [(item.manager) ? [_vm._v("\n            " + _vm._s(item.manager.first_name) + " " + _vm._s(item.manager.last_name) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left role-cell"
    }, [(item.manager) ? [_vm._v("\n              " + _vm._s(item.manager.phone) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left role-cell"
    }, [(item.manager) ? [_vm._v("\n            " + _vm._s(item.manager.username) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-center role-cell edit-cell"
    }, [_c('b-button', {
      staticClass: "edit",
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.onAddCompany($event, item.id)
        }
      }
    }, [_vm._v(" Edit")])], 1)])]
  })], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbc80d02","hasScoped":true}!./src/components/companies/companies.component.html
// module id = 555
// module chunks = 1